var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"chat-av",class:{ 'chat-av--group': _vm.group },style:(_vm.style),attrs:{"title":_vm.name}},[(_vm.group)?_c('i',{staticClass:"fe fe-users"}):[_vm._v(_vm._s(_vm.letters))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }